import React from "react";
import { useSelector } from "react-redux";
import defaultAvatar from "../../../../../images/default-avatar.png";
import "./styles.scss";

const AgentSelect = ({ details, data }) => {
  const settings = useSelector((store) => store.profile.settings);
  const dreLabel = settings?.DRENumberDisplayName || "#";

  return (
    <>
      {!details && <p className="title-agent-select">Select your Agent:</p>}
      <div
        className={!details ? "content-agent-select" : "content-agent-infos"}
      >
        <div className="item-agent-select">
          {!details && <input type="checkbox" name="" id="" />}
          <div className="dyna-photo-width">
            <div
              className="dyna-bg-img-round"
              style={{
                backgroundImage: `url(${
                  data.AgentPhotoMiniUrl || defaultAvatar
                })`,
              }}
            />
          </div>
          <div>
            <div className="text">
              <b>
                {data.FirstName} {data.LastnName}
              </b>
              {Boolean(data.DreNumber) && (
                <p>
                  {dreLabel}: {data.DreNumber || "N/A"}
                </p>
              )}
            </div>
            {details && (
              <div className="agent-info">
                <p>
                  Email: <a href={`mailto:${"data.Email"}`}>{data.Email}</a>
                </p>
                <p>Office: {data.OfficePhone}</p>
                <p>Mobile: {data.CellPhone || "N/A"}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AgentSelect;
